import { PortalLayout } from "js/components/admin/components/layouts/portal-layout";

 export const AdminIndex = [
     { path: "/admin/", component: PortalLayout },
     { path: "/", component: PortalLayout }
 ];
